import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";

import { archiveComment, Comment, deleteComment, DeleteComment } from "@/api";
import { useUser } from "@/providers/context";

export const useDeleteComment = () => {
  const { uid } = useUser();
  const queryClient = useQueryClient();

  return useMutation<
    boolean,
    AxiosError<{ detail: string }>,
    Omit<DeleteComment, "userId"> & { itemId: number; isArchive?: boolean }
  >(
    (variables) => {
      if (!uid) {
        return Promise.reject();
      }
      return variables.isArchive
        ? archiveComment({
            sourceCommentId: variables.sourceCommentId,
            sourceItemId: variables.sourceItemId,
            userId: uid,
          })
        : deleteComment({
            sourceCommentId: variables.sourceCommentId,
            sourceItemId: variables.sourceItemId,
            userId: uid,
          });
    },
    {
      onSuccess: async (_data, { itemId, sourceCommentId }) => {
        const queryKey = ["comments", itemId];
        const existingData = queryClient.getQueryData(queryKey) as
          | Comment[]
          | undefined;

        if (existingData) {
          const updatedComments = existingData
            ?.map((c) => {
              if (c.SourceCommentId === sourceCommentId) {
                return null;
              }
              return {
                ...c,
                Responses: c.Responses.filter(
                  (r) => r.SourceCommentId !== sourceCommentId,
                ),
              };
            })
            .filter((c) => c !== null);

          queryClient.setQueryData(queryKey, updatedComments);
        }
      },
    },
  );
};
